import { render, staticRenderFns } from "./price.vue?vue&type=template&id=2e7c4256&scoped=true"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"
import style0 from "./price.vue?vue&type=style&index=0&id=2e7c4256&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c4256",
  null
  
)

export default component.exports